import React from "react";

export const LANGUAGES = [
  { id: "English", label: "English" },
  { id: "Nigerian Pidgin", label: "Pidgin" },
  { id: "Yoruba", label: "Yorùbá" },
  { id: "Hausa", label: "Hausa" },
  { id: "Igbo", label: "Igbo" },
];

export const LanguagePicker = ({ value, onChange }) => (
  <div className="flex flex-wrap gap-2" data-testid="language-picker">
    {LANGUAGES.map((l) => (
      <button
        key={l.id}
        type="button"
        onClick={() => onChange(l.id)}
        className={`rounded-full px-3.5 py-1.5 text-sm font-semibold border transition-colors ${
          value === l.id ? "bg-clay text-white border-clay" : "bg-sand border-border text-ink/70 hover:border-clay/50"
        }`}
        data-testid={`language-${l.id.replace(/\s/g, "-").toLowerCase()}`}
      >
        {l.label}
      </button>
    ))}
  </div>
);
